import { toastService } from '@thefarmersfront/kitchen';

import { useAPI, useAsyncHandler } from '~/hooks/common';

import { TOAST_MESSAGE } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetOwnerSupplierShippingParams, TypeGetOwnerSupplierShippingResponse } from '~/types/vender.types';

const useGetOwnerSupplierShipping = () => {
  const { runAsync } = useAsyncHandler();

  const getOwnerSupplierShipping = useAPI<TypeGetOwnerSupplierShippingParams, TypeGetOwnerSupplierShippingResponse>({
    endpoint: '/api-owner/owner-supplier',
    method: 'get',
  });

  const requestOwnerSupplierShipping = async (
    { ownerSupplierCode, shippingType }: TypeGetOwnerSupplierShippingParams,
    {
      onSuccess,
      onError,
    }: { onSuccess?: (data: TypeGetOwnerSupplierShippingResponse['data']) => void; onError?: () => void }
  ) => {
    runAsync(() => getOwnerSupplierShipping({ pathParams: `/${ownerSupplierCode}/shipping/${shippingType}` }), {
      onSuccess: ({ data }) => {
        onSuccess?.(data);
      },
      onError: (error) => {
        toastService.addToast({
          type: 'error',
          message: (error as TypeErrorResponseData['error'])?.message || TOAST_MESSAGE.DEFAULT_ERROR,
        });
        onError?.();
      },
    });
  };

  return { requestOwnerSupplierShipping };
};

export default useGetOwnerSupplierShipping;
